import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from "./shared/shared.module";
import { HTTP_INTERCEPTORS, HttpClientModule, HttpRequest } from "@angular/common/http";
import { KeycloakAngularModule, KeycloakBearerInterceptor, KeycloakService } from "keycloak-angular";
import keycloakConfig from "./auth/config/KeycloakConfig";
import { environment } from '../environments/environment';
import { LoggingInterceptor } from './shared/services/logging-interceptor.service';
import { LoggingService } from './shared/services/logging.service';
import { GlobalErrorHandler } from './shared/services/global-error-handler.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';


function initializeKeycloak(keycloak: KeycloakService, loggingService: LoggingService) {
  return () =>
    keycloak.init({
      config: keycloakConfig,
      enableBearerInterceptor: true,
      authorizationHeaderName: 'Authorization',
      bearerPrefix: 'Bearer',
      shouldAddToken: (request: HttpRequest<unknown>) => true,
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
      }
    }).then(() => {
      const alreadyLogged = sessionStorage.getItem('logged');

  if (!alreadyLogged) {
    loggingService.logEvent('login_success');
    sessionStorage.setItem('logged', 'true');
  }

    }).catch((err) => {
      // login failed
      loggingService.logEvent('login_failed', {
        error_message: err?.message || 'Error during login'
      });
      throw err; //rethrow to block bootstrap
    });
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    KeycloakAngularModule
  ],
  providers: [
     { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, LoggingService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },
    ...(environment.enableLogging
      ? [{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true }]  // Conditionally register LoggingInterceptor
      : []
    ),
    provideAnimationsAsync('noop')
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
